import { type ReactNode, useState } from "react";
import type { Size } from "@/shared/components/generic/UiEnums.ts";
import ScheduleImportDayDialog from "@/pages/human-resources/time-management/schedules/site-schedule/day-view/import-dialog/ScheduleImportDayDialog.tsx";
import ScheduleImportDialogOpener from "@/pages/human-resources/time-management/components/schedule-import/ScheduleImportDialogOpener.tsx";
import { useTranslation } from "react-i18next";

interface Properties {
  disabled: boolean;
  buttonSize: Size;
}

export default function ScheduleImportDayOpener(props: Properties): ReactNode {
  const { t } = useTranslation("humanResources");
  const [popupOpen, setPopupOpen] = useState(false);
  return (
    <>
      <ScheduleImportDialogOpener
        tooltipLabel={t("timeManagement.scheduleImportDialog.day.title")}
        disabled={props.disabled}
        buttonSize={props.buttonSize}
        onClick={() => {
          setPopupOpen(true);
        }}
      />
      {popupOpen && (
        <ScheduleImportDayDialog
          onClose={() => {
            setPopupOpen(false);
          }}
        />
      )}
    </>
  );
}
